import { render, staticRenderFns } from "./FavoriteView.vue?vue&type=template&id=4b23f734&scoped=true&"
import script from "./FavoriteView.vue?vue&type=script&lang=js&"
export * from "./FavoriteView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b23f734",
  null
  
)

export default component.exports